/**
 * Programme type created by karora on 13/06/17.
 */
export class Programme {
  id: number;
  name: string;
  description: string;
  url: string;
  brand_image_id: number;
  active: boolean;
  client_id: number;
  short_name: string;
  default_recording_duration: number;
  response_count: number;
}
